
import React, { useState, useEffect } from "react";
import { FaFacebookF } from "react-icons/fa";
import { FcGoogle } from "react-icons/fc";
import { useDispatch, useSelector } from "react-redux";
import { login, register, getUser } from "../../Redux/Auth/Action";
import { useNavigate } from "react-router-dom";
import { Snackbar, Alert } from "@mui/material";
import { GoogleOAuthProvider, useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import './Sign.css'

const SignIn = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const jwt = localStorage.getItem("jwt");

  const auth = useSelector((store) => store.auth);
  const [isSignUp, setIsSignUp] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
  });

  const [openSnackbar, setOpenSnackbar] = useState(false);

  useEffect(() => {
    if (jwt) {
      dispatch(getUser(jwt));
    }
  }, [jwt]);

  useEffect(() => {

    if(auth.user){

      if (auth.user || auth.error) {
        setOpenSnackbar(true);
      }
      // console.log(auth.user)
      if (auth.user.role=="CUSTOMER") {
        navigate("/");
      }
      if (auth.user.role=="ADMIN") {
        navigate("/admin");
      }
  
    }
   
  }, [auth.user, auth.error]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isSignUp) {
      const { firstName, lastName, email, password } = formData;
      dispatch(register({ firstName, lastName, email, password }));
    } else {
      const { email, password } = formData;
      dispatch(login({ email, password }));
    }
  };

  const handleCloseSnackbar = () => setOpenSnackbar(false);


  const responseGoogle = async (authResult) => {
    try {

      if (authResult) {
      const result = await axios.get(`http://localhost:5454/auth/google?code=${authResult.code}`,{
       // const result = await axios.get(`https://jhonnsbackend.onrender.com/auth/google?code=${authResult.code}`,{
          
        })
        const { email, name, image } = result.data.user
        console.log("result", result.data.user)
        console.log("token", result.data.jwt)

        if (result.data.jwt) localStorage.setItem("jwt", result.data.jwt)
        navigate("/")


      }

      console.log(authResult)
    } catch (err) {
      console.log("error while requesting google", err)
    }
  }

  const googleLogin = useGoogleLogin({
    onSuccess: responseGoogle,
    onError: responseGoogle,
    flow: 'auth-code'
  })



  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-xl bg-white p-8 rounded-xl shadow-lg">
        <h2 className="text-3xl font-bold text-[#854d0e] mb-6">
          {isSignUp ? "Create Account" : "Sign In"}
        </h2>

        <form className="space-y-4" onSubmit={handleSubmit}>
          {isSignUp && (
            <div className="flex flex-col md:flex-row gap-4">
              <input
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                placeholder="First Name"
                required
                className="w-full border rounded-md px-4 py-2 text-[#854d0e]  focus:outline-[#854d0e]"
              />
              <input
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                placeholder="Last Name"
                required
                className="w-full border rounded-md px-4 py-2 text-[#854d0e] focus:outline-[#854d0e]"
              />
            </div>
          )}

          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Email"
            required
            className="w-full border rounded-md px-4 py-2 text-[#854d0e] focus:outline-[#854d0e]"
          />

          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            placeholder="Password"
            required
            className="w-full border rounded-md px-4 py-2 text-[#854d0e] focus:outline-[#854d0e]"
          />

          <button
            type="submit"
            className="w-full bg-[#854d0e] hover:opacity-90 text-white font-semibold py-2 rounded-md"
          >
            {isSignUp ? "Create Account" : "Sign In"}
          </button>
        </form>

        <p className="text-sm text-gray-600 mt-4 text-center">
          {isSignUp ? "Already have an account?" : "Don't have an account?"}{" "}
          <span
            onClick={() => setIsSignUp(!isSignUp)}
            className="text-[#854d0e] hover:underline cursor-pointer"
          >
            {isSignUp ? "Sign In" : "Sign Up"}
          </span>
        </p>

        <div className="flex items-center justify-between my-6">
          <hr className="w-full border-gray-300" />
          <span className="mx-2 text-gray-400">or</span>
          <hr className="w-full border-gray-300" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
          <button
            className="flex items-center justify-center border rounded-md py-2 hover:bg-gray-100 transition"
            onClick={() => googleLogin()}
          >
            <FcGoogle className="text-xl mr-2" />
            Sign in with Gmail
          </button>
    
        </div>

        <Snackbar
          open={openSnackbar}
          autoHideDuration={6000}
          onClose={handleCloseSnackbar}
        >
          <Alert
            onClose={handleCloseSnackbar}
            severity={auth.error ? "error" : "success"}
            sx={{ width: "100%" }}
          >
            {auth.error ? auth.error : isSignUp ? "Register Success" : "Login Success"}
          </Alert>
        </Snackbar>
      </div>
    </div>
  );
};

export default function SignInWithProvider() {
  return (
    <GoogleOAuthProvider clientId="66696626054-3lao7kbs78ffgno0gov31kq7v9v25m0d.apps.googleusercontent.com">
      <SignIn />
    </GoogleOAuthProvider>
  );
}
